import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalBase from "./ModalBase";
import SignInPanel from "../auth/SignInPanel";
import BuyerAccountModal from "./BuyerAccountModal";
import { useModal } from "../../js/hooks/useModal";
import { useAuth } from "../../js/hooks/useAuth";
import { useStore } from "../../js/state/store";
import { updateBuyer } from "../../js/api/buyersApi";
import { resolvePostAuthPath } from "../../js/auth/onboardingState";

export default function AccountGateHost() {
  const navigate = useNavigate();
  const accountModal = useModal("buyerAccount");
  const { register, session } = useAuth();
  const { state, dispatch } = useStore();
  const [, setTick] = useState(0);
  const updating = Boolean(session?.role === "buyer" || session?.role === "admin");

  function handleSignedIn(nextSession, role) {
    accountModal.close();
    const nextPath = state.ui.pendingPath;
    dispatch({ type: "SET_PENDING_PATH", payload: "" });
    if (nextPath && nextPath !== "/start") {
      navigate(nextPath);
      return;
    }
    navigate(resolvePostAuthPath(nextSession, role));
    setTick((n) => n + 1);
  }

  async function handleAccount(form) {
    try {
      if (session?.role === "buyer" || session?.role === "admin") {
        const next = { ...state.buyer.current, ...form };
        dispatch({ type: "SET_BUYER", payload: next });
        if (next.id) await updateBuyer(next.id, next);
        accountModal.close();
        return;
      }
      const result = await register(form);
      dispatch({ type: "SET_BUYER", payload: result.buyer });
      accountModal.close();
      const nextPath = state.ui.pendingPath;
      dispatch({ type: "SET_PENDING_PATH", payload: "" });
      if (nextPath && nextPath !== "/start") {
        navigate(nextPath);
      }
    } catch (error) {
      window.alert(error.message);
    }
  }

  if (updating) {
    return (
      <BuyerAccountModal
        isOpen={accountModal.isOpen}
        onClose={accountModal.close}
        onSubmit={handleAccount}
        initialValues={state.buyer.current}
      />
    );
  }

  return (
    <ModalBase isOpen={accountModal.isOpen} title="Sign in" onClose={accountModal.close} compact>
      <SignInPanel compact onSignedIn={handleSignedIn} />
    </ModalBase>
  );
}
